// App Imports
import * as UserRoutes from './user-auth'

// User - auth routes
const routes = {
  ...UserRoutes
}

export default routes
